import {PlTableColumn} from "pl-table"

export default {
  extends: PlTableColumn,
  props: {

    "show-overflow-tooltip": {
      default() {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/ni-ui/table/col/table_col.js